require('./brokerContributionInvestmentFundHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ContentBox } = require('commonsComponents/contentBox');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');
// @ helpers
const { formatAmount, formatAmountObject, getPlainAmountObject, formatPercentage } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
    BROKER_FUNDS_INDEX_VARIATION_DECIMALS,
    BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS,
    BROKER_FUNDS_PARTICIPATIONS_DECIMALS
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const language = getLanguage();

class BrokerContributionInvestmentFundHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immBrokerProductAdvancedSearch } = this.props;
        const immContributionFunds = this.props.immContributionFunds.getIn([
            'steps',
            0,
            'contributionFunds'
        ]);
        const name = immContributionFunds.get('name');
        const isin = immContributionFunds.get('isin');
        const rentability = formatPercentage(immContributionFunds.get('rentability'));
        const variationPoints = immContributionFunds.get('variationPoints', '').toString();
        const variationPercent = immContributionFunds.get('variationPercent', '').toString();
        const netAssetDayEndDate = immContributionFunds.getIn(['netAssetValue', 'dayEndDate']);
        const formattedEndDate = DateHelper.buildFormattedDate(
            netAssetDayEndDate,
            formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)
        );
        const holdingValue = this.props.immContributionFunds.get('holding');
        const netAssetDayEndValue = {
            amount: immContributionFunds.getIn(['netAssetValue', 'amount']),
            currency: immContributionFunds.getIn(['netAssetValue', 'currency']),
            decimalsLength: BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS
        };

        if (!netAssetDayEndDate || !holdingValue) {
            return null;
        }

        const plainAmountObject = getPlainAmountObject(netAssetDayEndValue);
        const currencySymbol = formatAmountObject(plainAmountObject, true).currencySymbol;
        const performanceYTDLabel = `${formatText('brokerContributionFund-performanceYTD')}: `;
        const performanceLastYearLabel = `${formatText('brokerContributionFund-lastYearProfitability')} ${DateHelper.getFullYear(DateHelper.todayDate()) - 1}: `;
        const immInstrumentList = immBrokerProductAdvancedSearch.getIn(['results','funds','instrumentsList']);
        let performanceLastYear;
        if (immInstrumentList) {
            const performanceLastYearValue = immInstrumentList.getIn([ 0, 'lastYearReturnValue']);
            performanceLastYear = performanceLastYearValue ?
            formatAmount(Number(performanceLastYearValue).toFixed(2)) + " %" :
            '-';
        }
        else {
            performanceLastYear = '-';
        }

        return (
            <ContentBox id="brokerStocksLikeHeader" customClassName="broker-contribution-fund-header broker-contribution-fund-header--funds">
                <div className="broker-contribution-fund-header__header row">
                    <div className="col-lg-8">
                        <div className="broker-contribution-fund-header__company-header">
                            <h2 className="broker-contribution-fund-header__company-name">
                                {name}
                            </h2>
                        </div>
                        <span className="broker-contribution-fund-header__isin">
                            <FormattedText value={'brokerContributionFund-isin'} />: {isin}
                        </span>
                    </div>

                    <div className="col-lg-4">
                        <div className="broker-contribution-fund-header__quote-box">
                            <div className="broker-contribution-fund-header__quote">
                                {performanceYTDLabel}
                                <span className="broker-contribution-fund-header__product-value">
                                    {rentability}
                                </span>
                            </div>
                            <div className="broker-contribution-fund-header__quote-last-year">
                                {performanceLastYearLabel}
                                <span className="broker-contribution-fund-header__product-value-last-year">
                                    {performanceLastYear}
                                </span>
                            </div>
                            <div className="broker-contribution-fund-header__liquidating-value">
                                <FormattedText value={'brokerContributionFund-netAssetDayEndDate'} />
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            </div>

                            <div className="broker-contribution-fund-header__index-box">
                                <span className="broker-contribution-fund-header__index-value">
                                    <StockExchangeIndexVariation
                                        variationPts={formatAmount(variationPoints, undefined, BROKER_FUNDS_INDEX_VARIATION_DECIMALS)}
                                        variationPerc={formatAmount(variationPercent)}
                                        currencySymbol={currencySymbol}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="broker-contribution-fund-header__wallet-last-price-section row">
                    <div className="broker-contribution-fund-header__last-price-container col-lg-6">
                        <span className="broker-contribution-fund-header__last-price-date">
                            <span className="broker-contribution-fund-header__last-value-date">
                                ({formattedEndDate})
                            </span>
                        </span>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

BrokerContributionInvestmentFundHeader.propTypes = {
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immContributionFunds: PropTypes.object.isRequired,
    modifier: PropTypes.string
};

module.exports = BrokerContributionInvestmentFundHeader;
